<template>
  <div v-if="ticket" class="resolved-request-banner">
    <p class="text">
      {{ t('chat.sys.banner.request_resolved') }}
    </p>
    <button v-track-click="BTN_EVTS.CHAT_ROOM_RESOLVED_SUPPORT_REQUEST" class="view-btn" @click="viewDetails">
      View
      <FaAngleRight class="arrow" />
    </button>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { PleasedUserInfo } from '@/common/types';
import { namespace } from 'vuex-class';
import { ListTicketDetail } from '@/common/api/models.pleased';
import { emitOpenMyRequest } from '@/common/eventBus';
import FaAngleRight from '@/components/icons/FaAngleRight.vue';
import { getRecentResolvedTicket } from '@/common/userRequest';
import trackClick, { BTN_EVTS } from '@/directives/trackClick';

const userModule = namespace('user');

@Component({
  components: {
    FaAngleRight,
  },
  directives: {
    trackClick,
  },
})
export default class ResolvedRequestBanner extends Vue {
  @userModule.State('pleasedUser') pleasedUser!: PleasedUserInfo;

  readonly BTN_EVTS = BTN_EVTS;

  ticket: ListTicketDetail | null = null;

  created() {
    this.fetchTicket();
  }

  async fetchTicket() {
    const data = await getRecentResolvedTicket(this.pleasedUser.userId);

    if (!data || !data.ticket || data.ticketReviews.length > 0) {
      return;
    }

    this.ticket = data.ticket;
  }

  viewDetails() {
    if (!this.ticket) {
      return;
    }

    emitOpenMyRequest(true);
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/base.scss';

.resolved-request-banner {
  width: 100%;
  padding: 1.2rem 1.8rem;
  background: $resolved-request-banner-background;

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2.4rem;

  font-weight: 500;
  font-size: 14px;
}

.text {
  color: $resolved-request-banner-text-color;
}

.view-btn {
  background: none;
  border: none;
  color: $resolved-request-banner-btn-color;

  cursor: pointer;
  display: flex;
  align-items: center;
}

.view-btn .arrow {
  margin-left: 5px;
}
</style>
